{
  "disclaimer": "Figures shown are illustrative examples, not records of an actual transaction; your amounts may differ."
}
